/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit No1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import MyBoards from './MyBoards/index'
import No from './No/index'
import OtherBoards from './OtherBoards/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function No1({
  children,
  viewPath = "/DesignSystem/TasksBoardsList/Boards/Content/Boards/Content/No"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let taskBoardsListIconOnlyValueData = fromData.useDataValue({ viewPath,
context: 'task_boards_list',
path: 'iconOnly',
})
let taskBoardsListTypeValueData = fromData.useDataValue({ viewPath,
context: 'task_boards_list',
path: 'type',
})
let aggregateData = fromHelpers.getView(taskBoardsListIconOnlyValueData, taskBoardsListTypeValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: aggregateData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'MyBoards'}>
<MyBoards
  viewPath={`${viewPath}/MyBoards`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'OtherBoards'}>
<OtherBoards
  viewPath={`${viewPath}/OtherBoards`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}